
import React from 'react';
import ShopBadge from '@/components/dashboard/products/components/ShopBadge';
import { useShopName } from '@/components/dashboard/products/hooks/useShopName';

interface CustomersHeaderProps {
  onAddCustomer: () => void;
  isAdding: boolean;
  selectedCount: number;
  onDelete?: () => void;
  shopId?: string;
  selectedCustomers?: string[];
}

const CustomersHeader = ({ 
  selectedCount,
  shopId,
  selectedCustomers = []
}: CustomersHeaderProps) => {
  const { shopName } = useShopName(shopId);

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Clients</h1>
        {shopId && shopName && (
          <ShopBadge shopId={shopId} shopName={shopName} />
        )}
      </div>
    </div>
  );
};

export default CustomersHeader;
